<template>
  <div>
    <div class="no-data">
      <svg viewBox="0 0 16 16">
        <use xlink:href="@/assets/sprite.svg#record" />
      </svg>
      <p>{{ $t('common.noRecords') }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'no-data',
};
</script>

<style>
.no-data {
  text-align: center;
  margin: 100px 0;
}
.no-data svg {
  width: 80px;
  height: 80px;
  fill: #158faf;
}
.no-data p {
  font-size: 21px;
  margin: 10px 0 0;
  font-weight: 800;
  color: #333333;
}
</style>
